import { render, staticRenderFns } from "./保存Button.vue?vue&type=template&id=2b7cdb91&scoped=true&"
import script from "./保存Button.ts?vue&type=script&lang=ts&"
export * from "./保存Button.ts?vue&type=script&lang=ts&"
import style0 from "./保存Button.css?vue&type=style&index=0&id=2b7cdb91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7cdb91",
  null
  
)

export default component.exports